import styled from 'styled-components'
import hidePasswordIcon from '../../images/icon-hide-password.svg'
import showPasswordIcon from '../../images/icon-show-password.svg'

const ShowHidePasswordButton = styled.div`
    z-index: 1000;
    align-self: flex-end;
    background-image: url(${props => props.showPassword ? hidePasswordIcon : showPasswordIcon});
    background-repeat: no-repeat;
    background-position: center;
    position: relative;
    box-sizing: border-box;
    top: 81px;
    margin-top: -32px;
    right: 6px;
    width: 30px;
    height: 26px;
`

export default ShowHidePasswordButton
